import { FC, ReactNode } from 'react'

import { Link } from '@remix-run/react'

import {
  Container,
  PageHeading,
  PrimaryButton,
  Link as ExternalLink,
} from '~/components'

const QuestionsAndAnswers: { questionText: string; answerText: ReactNode }[] = [
  {
    questionText: 'どんな会社が運営していますか？',
    answerText: (
      <>
        {`株式会社トランスリアルという企業です。
        ベンチャー・スタートアップ企業向けの小規模デザインオフィスの不動産仲介を中心とした事業を行なっています。
        `}
        公式サイトURL：
        <ExternalLink
          href="https://trancereal.co.jp/"
          rel="noreferrer noopener"
          target="_blank"
        >
          https://trancereal.co.jp/
        </ExternalLink>
      </>
    ),
  },
  {
    questionText: '個人情報は適切に管理されているのですか？',
    answerText:
      'officeMAPでは、国が定める法令や指針、規範を遵守しております。個人情報は法令に基づく場合を除いて、本人の同意を得ることなく第三者に提供することはございません。詳しくは、「利用規約」をご覧ください。',
  },
  {
    questionText: 'officeMAPの使い方がよくわかりません。',
    answerText: `「officeMAPの使い方」をご覧ください。
あなたに合ったオフィスの探し方や情報の見方、内覧申込の方法など、オフィスを探す工程に合わせて説明しているコンテンツがあります。`,
  },
  {
    questionText: '空き状況について確認する事はできますか？',
    answerText:
      'はい。お問い合わせフォームから、空き状況確認の旨を記載いただき、お送りください。',
  },
  {
    questionText: '内覧は無料ですか？',
    answerText: '内覧は全て無料です。料金が発生する事は一切ありません。',
  },
  {
    questionText: 'どのように内覧をすればよいでしょうか？',
    answerText: `内覧したいオフィスのページから、「問い合わせ」を押してください。
その後、入力フォームに情報をご入力いただき、送信ボタンを押すことで申込完了となります。`,
  },
  {
    questionText: '内覧申込したオフィスが既に埋まっていました。',
    answerText:
      '申し訳ございません。情報更新のタイミングにより、埋まってしまう場合がございますので、お問い合わせください。',
  },
  {
    questionText: '最短でいつから入れますか？',
    answerText:
      'オフィスごとに異なりますが、最短約1~2週間ほどで入居することが可能です。',
  },
  {
    questionText: '初期費用はどれくらいかかりますか？',
    answerText:
      'オフィスごとに異なりますが、敷金として賃料の2ヶ月分（原則返還）と、登録料などでさらに賃料の1ヶ月分（返還なし）がかかることが一般的です。',
  },
  {
    questionText: '東京以外のエリアのオフィス情報はないのですか？',
    answerText: '当初は東京のみとなっておりますが、順次拡大して参ります。',
  },
  {
    questionText: 'officeMAPで検索しても、希望の物件が見つかりません。',
    answerText: `下記のお問い合わせフォームより、ご希望の条件をお知らせください。
掲載している物件は弊社で取り扱っている情報の一部です。
既にお電話やメールでご希望条件を頂いているお客様に、サイト掲載前の情報をお送りしています。`,
  },
  {
    questionText: 'officeMAPにオフィスを掲載したいです。',
    answerText:
      'お手数ですが、info@officemap.comまで掲載希望の旨、ご連絡ください。',
  },
  {
    questionText: '掲載にあたって審査はございますか。',
    answerText:
      '必要情報をいただきましたら、当社にて審査を行います。まずはお気軽にお問い合わせください。',
  },
]

export const FaqPage: FC = () => {
  return (
    <main className="pb-36 pt-6 md:pt-10">
      <Container>
        <PageHeading className="mb-10">よくある質問</PageHeading>
        <div className="mb-6">
          {QuestionsAndAnswers.map(({ questionText, answerText }) => (
            <div
              className="mb-4 border-b border-grayBorder pb-6"
              key={questionText}
            >
              <div className="mb-4 flex gap-x-1 text-body-bold sm:gap-x-2">
                <span className="text-brand">Q</span>
                <span>{questionText}</span>
              </div>
              <div className="flex gap-x-1 text-body sm:gap-x-2">
                <span className="text-body-bold text-cta">A</span>
                <span className="whitespace-pre-line">{answerText}</span>
              </div>
            </div>
          ))}
        </div>
        <Link className="mx-auto block max-w-[220px]" to="/">
          <PrimaryButton color="brand">トップページへ</PrimaryButton>
        </Link>
      </Container>
    </main>
  )
}
